/**
 * Generated runtime TestId mirror for frontend/src/pages/reporting/ResultTable.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ResultTableTestIds = {
  btnExportCsv: "btn-export-csv",
  btnExportXlsx: "btn-export-xlsx",
  resultTable: "result-table",
  col: (col_name: string) => `col-${col_name}`,
  colPrefix: () => "col-" as TestIdPrefix
} as const;
